<script>

    import { toast } from 'bulma-toast'
    import { userStore, creditsStore, notifyStore, modalStore } from '../stores'

    import CreditsService from '../$services/credits.service'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'

    import Button from '../$components/button.svelte'
    
    let loading = false

    let data = {
        processor: 'admin'
    }

    async function createCredit() {

        data.userId = $userStore._id

        loading = true
        const resp = await CreditsService.createCredit(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notifyStore.set('wallet_updated')
        creditsStore.append(resp.data)

        toast({message: 'Crédito creado', type: 'is-success'})

        modalStore.close()
    }
</script>

<Form on:submit={ createCredit } { loading } >
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={ data.amount } label="Monto" placeholder="Monto" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.reference} label="Referencia" placeholder="Referencia de pago" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Select bind:value={ data.status } 
                label="Estatus"
                options={[
                    {value: 'paid', text: 'Pagado'},
                    {value: 'pending', text: 'Pendiente'},
                ]}
            />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>